module.exports = __webpack_public_path__ + "static/media/galerija_2021 (20)-min.e13e8e57.jpg";